var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mail_FILL0_wght400_GRAD0_opsz48 1",
    clipPath: "url(#clip0_323_229)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.3125 14C0.9625 14 0.65625 13.8687 0.39375 13.6062C0.13125 13.3438 0 13.0375 0 12.6875V1.3125C0 0.9625 0.13125 0.65625 0.39375 0.39375C0.65625 0.13125 0.9625 0 1.3125 0H16.1875C16.5375 0 16.8438 0.13125 17.1062 0.39375C17.3687 0.65625 17.5 0.9625 17.5 1.3125V12.6875C17.5 13.0375 17.3687 13.3438 17.1062 13.6062C16.8438 13.8687 16.5375 14 16.1875 14H1.3125ZM8.75 7.39375L1.3125 2.51562V12.6875H16.1875V2.51562L8.75 7.39375ZM8.75 6.08125L16.1 1.3125H1.42188L8.75 6.08125ZM1.3125 2.51562V1.3125V12.6875V2.51562Z",
    fill: "#7B7B7B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_323_229"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.5,
    height: 14,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.2d6451ca5b16cb38f497f7b26240e3b7.svg";
export { ForwardRef as ReactComponent };